import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  maxleaveinprobation: 0,
  maxleavedurationtype: [],
  maxleavedurationtypeid: null,
  maxconsecutiveleavedurationtype: [],
  maxconsecutiveleavedurationtypeid: null,
  maxleave: 0,
  maxconsecutiveleave: 0,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 1,
  notifyinadvanceday: 1,
  notifynotbeforeday: 1,
  apppastday: 1,
  ispastappallowed: false,
  isleaveallowedinnotice: false,
  leavecountinnotice: 1,
  handleLeaveCount: false,
  durationType: [
    { displayname: "Month", displayvalue: 1 },
    { displayname: "Quarter", displayvalue: 2 },
  ],
};
class LeaveUsageLimit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          leaveid: props.InitLeavesPolicy.policy[ParentIndex].leaveid,
          isfurtureappallowed:
            props.InitLeavesPolicy.policy[ParentIndex].isfurtureappallowed,
          minleavecountforapp:
            props.InitLeavesPolicy.policy[ParentIndex].minleavecountforapp,
          notifyinadvanceday:
            props.InitLeavesPolicy.policy[ParentIndex].notifyinadvanceday,
          notifynotbeforeday:
            props.InitLeavesPolicy.policy[ParentIndex].notifynotbeforeday,
          apppastday: props.InitLeavesPolicy.policy[ParentIndex].apppastday,
          ispastappallowed:
            props.InitLeavesPolicy.policy[ParentIndex].ispastappallowed,
          isleaveallowedinnotice:
            props.InitLeavesPolicy.policy[ParentIndex].isleaveallowedinnotice,
          leavecountinnotice:
            props.InitLeavesPolicy.policy[ParentIndex].leavecountinnotice,
          isallowhalfday:
            props.InitLeavesPolicy.policy[ParentIndex].isallowhalfday,
        },
        () => {
          if (this.state.leavecountinnotice > 0) {
            this.setState({ handleLeaveCount: true });
          }
        },
      );
    } else {
      this.setState({ ...ParentState });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isfurtureappallowed: this.state.isfurtureappallowed,
      minleavecountforapp: this.state.minleavecountforapp,
      notifyinadvanceday: this.state.notifyinadvanceday,
      notifynotbeforeday: this.state.notifynotbeforeday,
      apppastday: this.state.apppastday,
      ispastappallowed: this.state.ispastappallowed,
      isleaveallowedinnotice: this.state.isleaveallowedinnotice,
      leavecountinnotice: this.state.leavecountinnotice,
      isallowhalfday: this.state.isallowhalfday,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isallowhalfday":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "maxleavedurationtype":
      case "maxconsecutiveleavedurationtype": {
        this.setState({ [name]: arg[0] }, () => {
          this.options(name, arg);
        });
        break;
      }
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 1,
            notifynotbeforeday: 2,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      case "isleaveallowedinnotice":
        this.setState(
          { [name]: arg[0], leavecountinnotice: 0, handleLeaveCount: false },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "handleLeaveCount":
        this.setState({ [name]: arg[0], leavecountinnotice: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      default:
        break;
    }
  }

  options(name, selected) {
    const arg = selected[0];
    switch (name) {
      case "maxleavedurationtype":
        this.setState({ maxleavedurationtypeid: arg.displayvalue }, () => {
          this.UpdateReducer();
        });
        break;
      case "maxconsecutiveleavedurationtype":
        this.setState(
          { maxconsecutiveleavedurationtypeid: arg.displayvalue },
          () => this.UpdateReducer(),
        );
        break;
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {/* <p class="add-label-active2 margin-top-30">
                        <FormattedMessage id="LbLeaveUsageLimits" defaultMessage="Leave usage limits" />
                    </p> */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbAllowHalfDayApplication"
                defaultMessage="Would you like to allow half-day leave applications?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", true)}
              aria-expanded={this.state.isallowhalfday == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isallowhalfday == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", false)}
              aria-expanded={this.state.isallowhalfday == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isallowhalfday == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 3 */}
          <div className="inner-wrapper margin-top-20 opaque">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLimitFutureApplications"
                defaultMessage="Do you want to limit leave applications for future dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", true)}
              aria-expanded={this.state.isfurtureappallowed == true}
            >
              <span>
                {" "}
                <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
              </span>
              {this.state.isfurtureappallowed == true ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isfurtureappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbLeaveDurationGreater"
                  defaultMessage="If leave duration is greater than"
                />
                <InputValues
                  min="0"
                  max="365"
                  field="minleavecountforapp"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "minleavecountforapp",
                    365,
                  )}
                  value={this.state.minleavecountforapp}
                  defaultvalue={this.state.minleavecountforapp}
                />
                <span>days, </span>
                <br />
                <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifyinadvanceday",
                    365,
                  )}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                <span>days in advance,</span>
                <br />
                <FormattedMessage
                  id="__LbButNotEarlier1"
                  defaultMessage="but not earlier than"
                />

                {/* <FormattedMessage id="__LbApplicationMustBe" defaultMessage="days, employee must apply for a leave  atleast" />
                                <InputValues
                                    min="1"
                                    max="365"
                                    field="notifyinadvanceday"
                                    onChange={this.CommonNumberChange.bind(this, "notifyinadvanceday", 365)}
                                    value={this.state.notifyinadvanceday}
                                    defaultvalue={this.state.notifyinadvanceday}
                                />
                                days in advance, but not earlier than */}
                <InputValues
                  min={
                    (this.state.notifyinadvanceday &&
                      parseInt(this.state.notifyinadvanceday) + 1) ||
                    2
                  }
                  //   min={this.state.notifyinadvanceday && this.state.notifyinadvanceday}
                  max="365"
                  field="notifynotbeforeday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifynotbeforeday",
                    365,
                  )}
                  value={this.state.notifynotbeforeday}
                  defaultvalue={this.state.notifynotbeforeday || 2}
                />

                <FormattedMessage id="LbDays" defaultMessage="days" />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", false)}
              aria-expanded={this.state.isfurtureappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isfurtureappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 4 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbPastApplications"
                defaultMessage="Do you want to allow leave application for past dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", true)}
              aria-expanded={this.state.ispastappallowed == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.ispastappallowed == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.ispastappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbApplMadeUpTo"
                  defaultMessage="Leave application can be made upto"
                />
                <InputValues
                  min="1"
                  max="90"
                  field="apppastday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "apppastday",
                    90,
                  )}
                  value={this.state.apppastday}
                  defaultvalue={this.state.apppastday}
                />

                <FormattedMessage
                  id="LbActualLeaveDate"
                  defaultMessage="days after actual leave date"
                />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", false)}
              aria-expanded={this.state.ispastappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.ispastappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 5 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLeaveDuringNotice"
                defaultMessage="Do you want to allow the use of leaves during notice period?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", true)}
              aria-expanded={this.state.isleaveallowedinnotice == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isleaveallowedinnotice == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isleaveallowedinnotice}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <p className="depedent-select-list-head">
                  {/* <FormattedMessage
                    id="LbLeaveCount"
                    defaultMessage="How many leaves are allowed during notice period?"
                  /> */}
                  Do you wish to limit/cap the number of leaves allowed during
                  notice period
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("handleLeaveCount", true)}
                  aria-expanded={this.state.handleLeaveCount == true}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.handleLeaveCount == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level3">
                  <Collapse
                    in={this.state.handleLeaveCount}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage
                      id="LbAllowOnly"
                      defaultMessage="Allow only"
                    />
                    <InputValues
                      min="1"
                      max="300"
                      field="leavecountinnotice"
                      onChange={this.CommonNumberChange.bind(
                        this,
                        "leavecountinnotice",
                        300,
                      )}
                      value={this.state.leavecountinnotice}
                      defaultvalue={this.state.leavecountinnotice}
                    />

                    <FormattedMessage id="LbLeaves" defaultMessage="leaves" />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("handleLeaveCount", false)}
                  aria-expanded={this.state.handleLeaveCount == false}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.handleLeaveCount == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", false)}
              aria-expanded={this.state.isleaveallowedinnotice == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isleaveallowedinnotice == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
LeaveUsageLimit.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveUsageLimit)));
